import React, { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { clearSchoolData } from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";


import StatBox from "../../components/StatBox";

import { UserGroupIcon } from "@heroicons/react/20/solid";
import menu_schedule_solid from "../../assets/menu_schedule_solid.svg";
import menu_wallet_solid from "../../assets/menu_wallet_solid.svg";
import { TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForUsers } from "../../utils/confighelpers";
import RecentClassBooking from "../classes/booking/RecentClassBooking";
import UpcomingClassActivites from "../classes/UpcomingClassActivites";
import { getOnboardingRedirect } from "../../utils/onboarding";
import OnboardingTour from "../../components/onboarding/OnboardingTour";
import ClubDashboard from "./ClubDashboard";


export default function Home({ navigation }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userReduxState = useSelector(userState);
  const dashboardReduxState = useSelector(dashboardState);
  const [dashboardStatistics, setDashboardStatistics] = React.useState([
    {
      title: "Favourites",
      fullData: {},
      data: 0,
      bgColor: "bg-light-brown-coffee",
      icon: UserGroupIcon,
      // img: favourite_png,
      // update: "+3 this month",
      update: "",
    },
    {
      title: "Bookings",
      fullData: {},
      data: 0,
      bgColor: "bg-portland-orange",
      // icon: ShoppingCartIcon,
      img: menu_schedule_solid,
      update: "",
    },
    {
      title: "Revenue",
      fullData: {},
      data: 0,
      bgColor: "bg-lilac",
      // icon: CurrencyEuroIcon,
      img: menu_wallet_solid,
      update: "",
    },
  ]);
  const [backgroundForHome, setBackgroundForHome] = React.useState(false);

  const getUserInfo = async () => {
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config).catch(async (e) => {
      console.error("Session Has Expired");
      if (e.response && (e.response.status === 401 || e.response.status === 502)) {
        console.error("Session Has Expired");
        localStorage.removeItem("userToken");
        localStorage.removeItem("persist:root");
        dispatch(userActions.clearUserData());
        dispatch(clearSchoolData());
        dispatch(dashboardActions.clearDashboardData());
        await setUserToken("");
        window.location.href = "/";
      }
    });
    dispatch(setGlobalLoading(false));
    if (request.data.statusCode === 200) {
      // console.log("data", request.data.data);
      const userData = request.data.data;

      // setProfileDetails((prevValues) => ({
      //   ...prevValues,
      //   google_calendar_details: request.data.data?.google_calendar_details || {},
      // }));
      dispatch(userActions.setUserData(userData));
      // if (values) {
      //   dispatch(
      //     userActions.setUserPhone(values.formattedPhoneNumber)
      //   );
      // }
      /** New onboarding order: an owner without a plan or without club details is sent back to finish onboarding */
      const onboardingRedirect = getOnboardingRedirect(userData);
      if (onboardingRedirect) {
        navigation(onboardingRedirect, { replace: true });
        return;
      }
      /** Not finished onboarding and not sent anywhere above: the account isn't confirmed (same as before for step 0).
       *  The old wizard (/on-bording) and its steps are gone (2026-10-28). */
      if ((userData.onBoardingStep || 0) < 3) {
        await Logout("");
      } else if (userData.onBoardingStep >= 3) {
        setBackgroundForHome(true)
        if (request.data.data?.businessType) {
          // console.log("userData?.businessType", userData?.businessType);
          // console.log("userReduxState?.businessType", userReduxState?.businessType);
          // console.log("=", request.data.data?.businessType !== userReduxState.businessType);
          if (request.data.data?.businessType !== userReduxState.businessType) {
            await dispatch(userActions.setBusinessType(request.data.data?.businessType));
            // window.location.reload();
            setTimeout(() => {
              window.location.href = "/";
            }, 1000);
          }
        } else {
          await dispatch(userActions.setBusinessType("event"));
          // await dispatch(userActions.setBusinessType(""));
          await updateUserProfile()
        }
        // dispatch(
        //   schoolActions.setId(request.data.data.schoolObj.id)
        // );
        // dispatch(
        //   schoolActions.setName(
        //     request.data.data.schoolObj.schoolName
        //   )
        // );
        // dispatch(
        //   schoolActions.setLogo(request.data.data.schoolObj.logo)
        // );
        // dispatch(
        //   schoolActions.setCategories(
        //     request.data.data.seletedCategories
        //   )
        // );
        // setSubmitting(false);
        // dispatch(dashboardActions.setCalendarOpen(false));
        // navigation("/home/dashboard");
      }
    }
  }

  const Logout = async () => {
    try {
      await axiosInstance.put(
        `${getUrlForUsers()}logoutUser`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userToken,
          },
        }
      );
    } catch (err) {
      console.log("error", err);
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("persist:root");
      dispatch(userActions.clearUserData());
      dispatch(clearSchoolData());
      dispatch(dashboardActions.clearDashboardData());
      await setUserToken("");
      // navigate("/", { replace: true });
      window.location.href = "/";
    }
  };

  const fetchData = useCallback(async () => {
    // if (isMobile || isTablet) {
    //   // alert("isMobile");
    //   Logout("");
    //   return false;
    // }
    // class clubs get the new dashboard (ClubDashboard), whose tiles load these statistics themselves
    if (userReduxState?.businessType !== "class") getDashboardStatistics();
    getUserInfo();

    // return () => clearInterval(unsubscribe);
  }, [])

  React.useEffect(() => {
    // console.log("getUrlForEvent", (getUrlForEvent()));
    // console.log("getUrlForUsers", (getUrlForUsers()));
    // console.log("getUrlForClasses", (getUrlForClasses()));
    // console.log("getUrlForServices", (getUrlForServices()));
    // console.log("getUrlForFoods", (getUrlForFoods()));
    // console.log("isMobile", (isMobile));
    // console.log("isTablet", (isTablet));
    fetchData();
  }, []);

  const updateUserProfile = async () => {
    const requestConfig = {
      method: "put",
      url: `${getUrlForUsers()}updateProfile`,
      headers: {
        "x-access-token": userToken,
      },
      data: {
        businessType: userReduxState.businessType
      },
    };
    console.log("requestConfig", requestConfig);
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {

      }
    }
  };

  const getDashboardStatistics = async () => {
    const config = {
      method: "get",
      url: `${getUrlForUsers()}statistics?listFor=class`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axiosInstance.request(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        setDashboardStatistics([
          // {
          //   title: "Favourites",
          //   data: request.data.data.totalFavorite,
          //   bgColor: "bg-light-brown-coffee",
          //   icon: favourite_png,
          //   update: "",
          // },
          {
            title: "Members",
            fullData: request.data.data.members,
            data: request.data.data.members.totalMembers,
            bgColor: "bg-light-brown-coffee",
            icon: UserGroupIcon,
            // img: favourite_png,
            update: "",
          },
          {
            title: "Bookings",
            fullData: request.data.data.bookings,
            data: request.data.data.bookings.totalBookings,
            bgColor: "bg-portland-orange",
            // icon: ShoppingCartIcon,
            img: menu_schedule_solid,
            update: "",
          },
          {
            title: "Revenue",
            fullData: request.data.data.bookingAndPurchaseRevenue,
            data: request.data.data.bookingAndPurchaseRevenue.totalRevenue,
            bgColor: "bg-lilac",
            // icon: CurrencyEuroIcon,
            img: menu_wallet_solid,
            update: "",
          },
        ]);
      }
    }
  };


  if (userToken === undefined || !userToken || userToken.length < 1) {
    // navigate("/", { replace: true });
  }

  /** Class clubs get the new club dashboard (tiles + insights); other business types keep the old one. */
  if (userReduxState.businessType === "class") {
    return (
      <TwMainLayout
        children={
          <>
            <OnboardingTour userId={userReduxState?.userData?._id} />
            <ClubDashboard />
          </>
        }
      />
    );
  }

  return (
    <TwMainLayout
      headTitle={"Dashboard"}
      navBarTitleComp={
        <h3 className={"font-extrabold text-2xl text-brown-coffee"}>
          Dashboard
        </h3>
      }
      children={<div className="flex flex-col gap-3 p-5">
        <OnboardingTour userId={userReduxState?.userData?._id} />
        <div className={`bg-[${backgroundForHome ? "1#EBEBEB" : "#fff"}]`}>
          {userReduxState.businessType !== "event" && (<div
            // className={`flex flex-row sm:flex-col gap-4 grid-cols-[395px_395px_395px] ${
            className={`grid grid-cols-1 gap-5 sm:grid-cols-3 lg:grid-cols-3 sm:gap-4`}
          >
            {dashboardStatistics.map((stat, idx) => (
              <StatBox {...stat} key={idx} />
            ))}
          </div>)}
          {(userReduxState.businessType === "class") ? <UpcomingClassActivites /> : ("")}
          {(userReduxState.businessType === "class") ? (
            <RecentClassBooking
              title="Recent Bookings"
              bookingType="teacherRecentBookings"
            />
          ) : ""}
        </div>
      </div>} />
  );
}
